'use client'

import type { FC } from 'react'
import { useId, useState } from 'react'
import { Button } from '../atoms/Button'
import { Overlay } from '../molecules/Overlay'

type ButtonFormOverlayBlockProps = {
	text: string
	iframeUrl: string
}

export const ButtonFormOverlayBlock: FC<ButtonFormOverlayBlockProps> = ({ text, iframeUrl }) => {
	const [open, setOpen] = useState(false)
	const labelId = useId()
	const overlayId = useId()

	return (
		<div>
			<Button
				intent="primary"
				theme="white"
				label={text}
				title={text}
				id={labelId}
				type="button"
				onClick={() => setOpen(true)}
				aria-controls={overlayId}
				aria-expanded={open}
			/>
			<Overlay
				open={open}
				setOpen={setOpen}
				aria-labelledby={labelId}
				id={overlayId}
				wrapChildren={false}
			>
				<iframe src={iframeUrl} className="w-full h-full" />
			</Overlay>
		</div>
	)
}
